import { render } from "./LingquRecord.vue?vue&type=template&id=f913b230&scoped=true"
import script from "./LingquRecord.vue?vue&type=script&lang=js"
export * from "./LingquRecord.vue?vue&type=script&lang=js"

import "./LingquRecord.vue?vue&type=style&index=0&id=f913b230&lang=stylus&scoped=true"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f913b230"]])

export default __exports__